import React, { Fragment } from "react";
import cx from "classnames";

import { connect } from "react-redux";

import { CSSTransition, TransitionGroup } from '../../utils/TransitionWrapper';

import HeaderLogo from "../AppLogo";

import SearchBox from "./Components/SearchBox";
import UserBox from "./Components/UserBox";
import SidebarToggleIcon from "../../components/SidebarToggleIcon";
import { setEnableClosedSidebar, setEnableMobileMenu } from "../../reducers/ThemeOptions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../../auth/AuthContext";
import Breadcrumbs from "../../components/Breadcrumbs";

const Header = ({
  headerBackgroundColor,
  enableMobileMenuSmall,
  enableMobileMenu,
  enableHeaderShadow,
  enableClosedSidebar,
  setEnableClosedSidebar,
  setEnableMobileMenu,
  isDesktop,
}) => {
  const toggleSidebar = () => {
    if (isDesktop) {
      setEnableClosedSidebar(!enableClosedSidebar);
    } else {
      setEnableMobileMenu(!enableMobileMenu);
    }
  };
  const { logout } = useAuth();
  const onLogoutClick = () => {
    logout();
    window.location.hash = "#/login";
  };
  return (
    <Fragment>
      <TransitionGroup>
        <CSSTransition component="div"
          className={cx("app-header", headerBackgroundColor, {
            "header-shadow": enableHeaderShadow,
          })}
          appear={true} timeout={1500} enter={false} exit={false}>
          <HeaderLogo />
          <div className={cx("app-header__content", {
              "header-mobile-open": enableMobileMenuSmall,
            })}>
            <div className="app-header-left">
              <div className="header__pane me-2" style={{ marginLeft: -18, display: 'flex', alignItems: 'center' }}>
                <SidebarToggleIcon toggled={isDesktop ? enableClosedSidebar : enableMobileMenu} onToggle={toggleSidebar} size={26} color="#6c757d" />
              </div>
              <Breadcrumbs />
            </div>
            <div className="app-header-right">
              <SearchBox />
              <UserBox />
              {/* Right divider to mirror the left one */}
              <div
                style={{
                  width: 1,
                  height: 24,
                  backgroundColor: "rgba(0,0,0,0.1)",
                  marginLeft: 12,
                  marginRight: 12,
                }}
              />
              <button
                type="button"
                className="btn btn-link p-0"
                onClick={onLogoutClick}
                title="Logout"
                aria-label="Logout"
                style={{ color: 'var(--cryrDarkBlue)' }}
              >
                <FontAwesomeIcon icon={faRightFromBracket} size="lg" />
              </button>
            </div>
          </div>
        </CSSTransition>
      </TransitionGroup>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  enableHeaderShadow: state.ThemeOptions.enableHeaderShadow,
  closedSmallerSidebar: state.ThemeOptions.closedSmallerSidebar,
  headerBackgroundColor: state.ThemeOptions.headerBackgroundColor,
  enableMobileMenuSmall: state.ThemeOptions.enableMobileMenuSmall,
  enableMobileMenu: state.ThemeOptions.enableMobileMenu,
  enableClosedSidebar: state.ThemeOptions.enableClosedSidebar,
  isDesktop: state.ThemeOptions.isDesktop,
});

const mapDispatchToProps = (dispatch) => ({
  setEnableClosedSidebar: (enable) => dispatch(setEnableClosedSidebar(enable)),
  setEnableMobileMenu: (enable) => dispatch(setEnableMobileMenu(enable)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
